import React from 'react'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'
import Text from 'components_new/atoms/Text'
import Tooltip from 'components_new/atoms/Tooltip'

import Avatar from './Avatar'

interface FeedbackNudgeProps {
  rated: boolean
  onRateUp: () => void
  onRateDown: (event: React.MouseEvent<HTMLElement>) => void
  onClose: () => void
}

// Local prompt asking the user to rate the latest answer. Never sent to the
// model or persisted.
const FeedbackNudge = (props: FeedbackNudgeProps) => {
  const { rated, onRateUp, onRateDown, onClose } = props

  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
      <Avatar size={32} />

      <Box
        sx={{
          bgcolor: 'action.hover',
          borderRadius: 2,
          flex: 1,
          minWidth: 0,
          position: 'relative',
          pl: 1.5,
          pr: 5,
          py: 1
        }}
      >
        <Text variant="body1">
          {t('chat', rated ? 'nudge_thanks' : 'nudge_text')}
        </Text>

        {!rated ? (
          <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
            <Button
              onClick={onRateUp}
              size="small"
              startIcon={<Icon fontSize="small" name="ThumbUpAltOutlined" />}
              variant="outlined"
            >
              {t('chat', 'feedback_helpful')}
            </Button>
            <Button
              onClick={onRateDown}
              size="small"
              startIcon={<Icon fontSize="small" name="ThumbDownAltOutlined" />}
              variant="outlined"
            >
              {t('chat', 'feedback_not_helpful')}
            </Button>
          </Box>
        ) : null}

        <Tooltip title={t('global', 'close')}>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ position: 'absolute', right: 4, top: 4 }}
          >
            <Icon fontSize="small" name="Close" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  )
}

export default FeedbackNudge
